import { FormLabel, Grid, Typography } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";
import { SwissGermanLocale, SwissTimeZone } from "../../../data/constants";
import { ExamType, ExamTypeTranslationKey } from "../../../model/Exam";
import { InternalTaskViewModel } from "../../../model/InternalTaskViewModel";
import { GetTranslatedValueIntl } from "../../../model/Shared/TranslatedValue";
import { getTimeSlotLabel } from "../../../utils/TimeSlotUtils";
import TranslatedMessage from "../../translations/TranslatedMessage";

const ModuleFields: React.FC<{ task: InternalTaskViewModel }> = ({ task }) => {
  const intl = useIntl();

  return (
    <Grid item container direction="column" xs={12} md={6} lg={6}>
      <Typography style={{ fontWeight: "bold" }}>
        <TranslatedMessage id="cancellationTaskForm.moduleSubHeader" />
      </Typography>

      <Grid item container direction="row" alignItems="baseline">
        <Grid item xs={12} sm={6} md={4}>
          <FormLabel>
            <TranslatedMessage id="cancellationTaskForm.sessionLabel" />
          </FormLabel>
        </Grid>
        <Grid item xs={12} sm={6} md={8}>
          <Typography>{GetTranslatedValueIntl(intl, task.examSessionKey)}</Typography>
        </Grid>
      </Grid>

      {task.examType !== ExamType.TermPaper && (
        <React.Fragment>
          <Grid item container direction="row" alignItems="baseline">
            <Grid item xs={12} sm={6} md={4}>
              <FormLabel>
                <TranslatedMessage id="cancellationTaskForm.dateLabel" />
              </FormLabel>
            </Grid>
            <Grid item xs={12} sm={6} md={8}>
              <Typography>
                {task.examDate ? new Date(task.examDate).toLocaleDateString(SwissGermanLocale, { timeZone: SwissTimeZone }) : ""}
              </Typography>
            </Grid>
          </Grid>

          <Grid item container direction="row" alignItems="baseline">
            <Grid item xs={12} sm={6} md={4}>
              <FormLabel>
                <TranslatedMessage id="cancellationTaskForm.locationLabel" />
              </FormLabel>
            </Grid>
            <Grid item xs={12} sm={6} md={8}>
              <Typography>{task.examLocation}</Typography>
            </Grid>
          </Grid>

          <Grid item container direction="row" alignItems="baseline">
            <Grid item xs={12} sm={6} md={4}>
              <FormLabel>
                <TranslatedMessage id="cancellationTaskForm.roomLabel" />
              </FormLabel>
            </Grid>
            <Grid item xs={12} sm={6} md={8}>
              <Typography>{task.examRoom}</Typography>
            </Grid>
          </Grid>

          <Grid item container direction="row" alignItems="baseline">
            <Grid item xs={12} md={4}>
              <FormLabel>
                <TranslatedMessage id="cancellationTaskForm.timeSlotLabel" />
              </FormLabel>
            </Grid>
            <Grid item xs={12} md={8}>
              <Typography>{task.examTimeSlot ? getTimeSlotLabel(task.examTimeSlot) : ""}</Typography>
            </Grid>
          </Grid>
        </React.Fragment>
      )}

      <Grid item container direction="row" alignItems="baseline">
        <Grid item xs={12} sm={6} md={4}>
          <FormLabel>
            <TranslatedMessage id="common.module" />
          </FormLabel>
        </Grid>
        <Grid item xs={12} sm={6} md={8}>
          <Typography>{GetTranslatedValueIntl(intl, task.moduleName)}</Typography>
        </Grid>
      </Grid>

      <Grid item container direction="row" alignItems="baseline">
        <Grid item xs={12} sm={6} md={4}>
          <FormLabel>
            <TranslatedMessage id="common.exam" />
          </FormLabel>
        </Grid>
        <Grid item xs={12} sm={6} md={8}>
          <Typography>{GetTranslatedValueIntl(intl, task.examName)}</Typography>
        </Grid>
      </Grid>

      <Grid item container direction="row" alignItems="baseline">
        <Grid item xs={12} sm={6} md={4}>
          <FormLabel>
            <TranslatedMessage id="cancellationTaskForm.examTypeLabel" />
          </FormLabel>
        </Grid>
        <Grid item xs={12} sm={6} md={8}>
          <Typography>
            {task.examType && <TranslatedMessage id={ExamTypeTranslationKey[task.examType]} />}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ModuleFields;
